import http from './http';

export const postMessageContact = (data) => http.post('/contato', data);


// WEBPACK FOOTER //
// ./src/services/Contact.js